module.exports = __webpack_public_path__ + "static/media/atendimento_sac.033ac427.png";